<template>
  <div id="logout-page">
    <v-row align="center" justify="center">
      <v-col align="center">
        <v-form>
          <!-- <v-btn class="mb-5" @click="testing1()" color="red"> Back #1 tests </v-btn>
          <v-spacer />
          <v-btn class="mb-5" @click="testing2()" color="orange"> Back #2 tests </v-btn>
          <v-spacer />
          <v-btn class="mb-5" @click="testing3()" color="yellow"> Back #3 tests </v-btn>
          <v-spacer />
          <v-btn class="mb-5" @click="testing4()" color="green"> Back #4 tests </v-btn>
          <v-spacer />
          <v-btn class="mb-5" @click="testing5()" color="cyan"> Back #5 tests </v-btn>
          <v-spacer />
          <v-btn class="mb-5" @click="testing6()" color="blue"> Back #6 tests </v-btn>
          <v-spacer />
          <v-btn class="mb-5" @click="getoff()" color="purple"> Disconnect </v-btn>
          <v-spacer /> -->
          <v-progress-circular :size="60" :width="4" color="primary" indeterminate/>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import backend from "@/api/backend";
import backlog from "@/api/backlog";
export default {
  name: "Logout",
  methods: {
    testing1() {
      let installsrc = -7;
      let installdst = -3;
      try {
        backend.get_blocs_install(installsrc).then(res => {
          // console.log(res.data);
          backend.put_blocs_install(installdst,res.data).then(txt => {
            console.log(txt.data);
          });
        });
        backend.get_m_pts_install(installsrc).then(res => {
          // console.log(res.data);
          backend.put_m_pts_install(installdst,res.data).then(txt => {
            console.log(txt.data);
          });
        });
        backend.get_edges_install(installsrc).then(res => {
          // console.log(res.data);
          backend.put_edges_install(installdst,res.data).then(txt => {
            console.log(txt.data);
          });
        });
      } catch (err) {
        console.error(err);
      }
    },
    testing2() {
      let alarmsrc = -7;
      let alarmdst = -3;
      try {
        backend.get_alarm_id(alarmsrc).then(res => {
          console.log(res.data);
          backend.put_alarm_id(alarmdst,res.data.install_id,res.data.json_data).then(txt => {
            console.log(txt.data);
          });
        });
      } catch (err) {
        console.error(err);
      }
    },
    async testing3() {
      let inverters = await backend.get_models_inverters(-1);
      console.log(inverters.data);
      backend.post_model_inverter(-1, inverters.data[0])
      let installs = await backend.get_installs();
      // console.log(installs.data);
      // installs = await backend.claim_new_install_id();
      // console.log(installs.data.install_id);
      installs = await backend.put_install_form(3, [{"kuma":0},[{"one":1}],[{"two":2}],[{"three":3}],[{"four":4}],[{"five":5}]]);
      console.log(installs.data);
    },
    async testing4() {
      let user_id = -3;
      let draftlist = await backend.get_all_drafts(user_id);
      console.log(draftlist.data);
      let newdraft = await backend.post_new_draft(user_id, 0, "draftOK", {"Answer": 42});
      console.log(newdraft.data);
      let editdraft = await backend.put_draft_to_id(user_id, 0, newdraft.data.id, "now KO", {"Answer": 8});
      console.log(editdraft.data);
      let deldraft = await backend.delete_draft_from_id(user_id, newdraft.data.id);
      console.log(deldraft.data);
    },
    async testing5() {
      let install_id = 181;
      let metalist = await backend.get_all_production_data_metadatas(install_id);
      console.log(metalist.data);
      let filetqt = new File(["feur"], "test.txt");
      let newfile = await backend.post_new_production_data(install_id, filetqt, 0);
      console.log(newfile.data);
      let editfile = await backend.put_production_data_to_id(newfile.data.id, install_id, filetqt, 2);
      console.log(editfile.data);
      let herefile = await backend.get_production_data_from_id(newfile.data.id, install_id);
      console.log(herefile);
      let delfile = await backend.delete_production_data_from_id(newfile.data.id, install_id);
      console.log(delfile);
    },
    async testing6() {
      let install_id = 8724;

      console.log((await backlog.delete_install_by_id(install_id)).data);
      console.log((await backlog.get_user_infos()).data);
      console.log((await backlog.get_all_installs()).data);
      console.log((await backlog.create_new_install()).data);
      console.log((await backlog.post_helio_install(install_id)).data);
      console.log((await backlog.put_install_by_id(install_id,
        [{ "kuma": 0 }, [{ "one": 1 }], [{ "two": 2 }], [{ "three": 3 }], [{ "four": 4 }], [{ "five": 5 }]])).data);
      console.log((await backlog.get_install_by_id(install_id)).data);

      console.log((await backlog.post_new_edge(install_id, [[0,0],[0,1]])).data);
      const edge_id = (await backlog.post_new_edge(install_id, [])).data.id;
      console.log((await backlog.put_edges_by_id(edge_id, [[1,2,1,1]])).data);
      console.log((await backlog.get_edges_by_id(edge_id)).data);
      console.log((await backlog.delete_edges_by_id(edge_id)).data);
      console.log((await backlog.post_edges_by_install_id(install_id,
        [{coordinates: [[0,0,0],[1,1,1]]},{coordinates: [[0,1,0],[1,0],[]]}])).data);
      console.log((await backlog.get_edges_by_install_id(install_id)).data);
      // console.log((await backlog.delete_edges_by_install_id(install_id)).data);

      console.log((await backlog.post_new_bloc(install_id, [[0,0],[0,1]], ["1-1","5-T"])).data);
      const bloc_id = (await backlog.post_new_bloc(install_id, [], [""])).data.id;
      console.log((await backlog.put_blocs_by_id(bloc_id, [[1,2,1,1]], ["42"])).data);
      console.log((await backlog.get_blocs_by_id(bloc_id)).data);
      console.log((await backlog.delete_blocs_by_id(bloc_id)).data);
      console.log((await backlog.post_blocs_by_install_id(install_id,
        [{coordinates: [[0,0,0],[1,1,1]], measure_pts: []},{coordinates: [[0,1,0],[1,0],[]], measure_pts: [""]}])).data);
      console.log((await backlog.get_blocs_by_install_id(install_id)).data);
      // console.log((await backlog.delete_blocs_by_install_id(install_id)).data);
      console.log((await backlog.post_visudatas(install_id, "ff", [], [])).data);
      console.log((await backlog.get_visudatas(install_id)).data);
    },
    getoff() {
      this.logout();
    },
    ...mapActions(["logout"])
  },
  created() {
    this.logout();
  }
};
</script>

<style lang="scss">
</style>
